import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@app/core/components/loader/loader.component';
import { HttpClientModule } from '@angular/common/http';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MaterialModule } from '@app/material/material.module';
import { LeaveSiteConformationDialogComponent } from '../shared/components/leave-site-conformation-dialog/leave-site-conformation-dialog.component';
@NgModule({
  declarations: [LoaderComponent, ForgotPasswordComponent, LeaveSiteConformationDialogComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    
  ],
  exports: [LoaderComponent, ForgotPasswordComponent],
  providers: [
  ]
})
export class CoreModule { }

